import React, { useEffect } from 'react'
import { observer } from 'mobx-react';
import './style.scss';
var mobile = require('is-mobile');

const ViewProject = observer(() => {

    useEffect(() => {
    }, []);

    if (mobile()) {
        return (
            <div>

            </div>
        );

    } else {
        return (
            <div className='ViewProject-Container'>
 
            </div>
        )
    }
})

export default ViewProject;